import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { resetApplicationStoreWithoutUserSession } from '../../../common/redux/purgeStore';

const APP_VERSION_STORAGE_KEY = 'app_deployment_version';

const useInvalidateAppCache = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (import.meta.env.MODE && import.meta.env.MODE !== 'development') {
      const currentVersion = process.env.VITE_VERSION;
      const storedVersion = localStorage.getItem(APP_VERSION_STORAGE_KEY);
      if (currentVersion) {
        const isDeploymentChanged =
          storedVersion && storedVersion !== currentVersion;

        if (isDeploymentChanged) {
          // Update stored version in localStorage
          localStorage.setItem(APP_VERSION_STORAGE_KEY, currentVersion);

          dispatch(resetApplicationStoreWithoutUserSession());
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else if (!storedVersion) {
          // First time - store the version but don't reload
          localStorage.setItem(APP_VERSION_STORAGE_KEY, currentVersion);
        }
      }
    }
  }, [location]);
};

export default useInvalidateAppCache;
